var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankOfAmerica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9639 13.0097C15.7534 9.7618 21.0767 6.60409 24 5.46732C23.5489 5.17861 22.8451 4.7636 22.0511 4.3125C18.2797 5.55754 13.8767 8.31828 9.94287 11.4399C10.6105 11.9451 11.3143 12.4684 11.9639 13.0097Z",
    fill: "#E31837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2316 4.18512C9.67225 3.91446 9.05871 3.66184 8.58954 3.44531C7.16397 4.14903 5.30534 5.21363 2.95947 6.89173C3.46474 7.16239 4.00609 7.48718 4.58353 7.81197C6.38804 6.47671 8.2106 5.21363 10.2316 4.18512Z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6058 2.6342C12.9201 2.25527 10.5381 1.37111 8.89601 0.992188C8.40879 1.17263 7.72308 1.44329 7.25391 1.64177C7.84939 1.80417 10.0689 2.39962 11.9637 3.35596C12.4509 3.12139 13.1366 2.83268 13.6058 2.6342Z",
    fill: "#E31837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53985 2.39844C3.42857 3.37282 1.20902 4.70808 0 5.48397C0.433083 5.68246 0.866161 5.84485 1.46165 6.13356C4.13233 4.32915 6.22556 3.22846 7.05563 2.86758C6.46014 2.65105 5.90075 2.5067 5.53985 2.39844Z",
    fill: "#012169"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1941 2.07507C15.6813 1.91267 16.2407 1.76832 16.7279 1.62396C15.3204 1.02851 13.552 0.396969 11.964 0C11.7114 0.0721762 10.9535 0.270661 10.4302 0.433057C10.9715 0.595454 12.758 1.01047 15.1941 2.07507ZM6.29785 8.85963C6.8753 9.20247 7.48882 9.67161 8.08431 10.0686C12.0362 7.00109 15.9339 4.63732 20.2106 3.30206C19.6151 2.99531 19.0918 2.72465 18.4242 2.39986C15.8618 3.04944 11.4768 4.79972 6.29785 8.85963Z",
    fill: "#E31837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankOfAmerica);
export default __webpack_public_path__ + "static/media/BankOfAmerica.049efd901164e549602864aa0466a0a2.svg";
export { ForwardRef as ReactComponent };